module.exports = __webpack_public_path__ + "static/media/belnovosti.72d0225d.svg";